<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="1" *ngIf="this.auth?.detailuser != undefined"></left-panel>
    </div>
    <div class="post-login-2-col-2 p-0 h-100 has-banner overflow-y-hidden">
        <img src="~/../assets/images/left-banner.jpg" style="height: 100%; min-width: 100%;" alt="">
    </div>
    <div class="post-login-2-col-3 bg-base-100">
        <div class="p-20">
            <!-- =========================================================== -->
            <!-- Mobile screen #3-4: Rewards Catalog                        -->
            <!-- Balance banner + horizontal chips + sort + reward list    -->
            <!-- =========================================================== -->

            <!-- Section A: Balance banner (uses the same dark loyalty-card image as the carousel) -->
            <div class="balance-banner">
                <img src="../../assets/images/bg-loyalty-card-slider.jpg" class="balance-banner-bg" alt="" />
                <div class="balance-banner-overlay">
                    <div class="balance-value">
                        <span class="balance-number">{{ (redeem?.LoyaltyCard?.rewardsBalance | number:'1.0-0') || '—' }}</span>
                        <span class="balance-label">{{ "LoyaltyPoints" | translate }}</span>
                    </div>
                    <div class="balance-expiry" *ngIf="redeem?.LoyaltyCard?.pointsExpiringInNextThreeMonths && redeem?.LoyaltyCard?.pointsExpiringInNextThreeMonths !== '0' && redeem?.LoyaltyCard?.pointsExpiringInNextThreeMonths !== 0">
                        {{ (redeem?.LoyaltyCard?.pointsExpiringInNextThreeMonths | number:'1.0-0') }}
                        {{ "PointsExpiringNext3Month" | translate }}
                    </div>
                    <div class="balance-expiry" *ngIf="!redeem?.LoyaltyCard?.pointsExpiringInNextThreeMonths || redeem?.LoyaltyCard?.pointsExpiringInNextThreeMonths === '0' || redeem?.LoyaltyCard?.pointsExpiringInNextThreeMonths === 0">
                        {{ "NoPointsExpiring" | translate }}
                    </div>
                </div>
            </div>

            <!-- Section B: Category chips (horizontal scroll) -->
            <div class="category-filter-chips mt-15">
                <div class="chips-scroll">
                    <span *ngFor="let cat of redeemCategories"
                          class="chip-item"
                          [class.chip-active]="selectedRedeemCategory === cat.id"
                          (click)="filterByRedeemCategory(cat.id)">
                        <img *ngIf="getCategoryIcon(cat.id)" [src]="getCategoryIcon(cat.id)" class="chip-icon" alt="" />
                        {{ cat.label }}
                    </span>
                </div>
            </div>

            <!-- Section C: Section header + sort -->
            <div class="catalog-section-header">
                <span class="catalog-section-title">{{ "RecommendedForYou" | translate }}</span>
                <button type="button" class="sort-control" (click)="toggleSort()" [attr.aria-label]="'SortBy' | translate">
                    <span class="sort-icon" [class.sort-icon-asc]="sortOrder === 'asc'" [class.sort-icon-desc]="sortOrder === 'desc'">
                        <ng-icon iconClass="icon-setting-arrow-right" width="11" height="11"></ng-icon>
                    </span>
                    <span class="sort-label">
                        {{ sortOrder === 'asc' ? ('LowestFirst' | translate) : ('HighestFirst' | translate) }}
                    </span>
                </button>
            </div>

            <!-- Section D: Reward list -->
            <div class="reward-list">
                <div class="reward-row"
                     *ngFor="let partner of getSortedPartners()"
                     (click)="openDetailsModal(partner)">
                    <div class="reward-row-icon">
                        <img *ngIf="partner.imageUrl" [src]="partner.imageUrl" alt="" (error)="partner.imageUrl = ''" />
                        <div *ngIf="!partner.imageUrl" class="reward-row-icon-fallback">
                            <span class="reward-row-icon-letter">{{ (partner.displayValue || '?').charAt(0) }}</span>
                        </div>
                    </div>
                    <div class="reward-row-body">
                        <div class="reward-row-name">{{ partner.displayValue }}</div>
                        <span class="reward-row-category-chip">{{ partner.category }}</span>
                    </div>
                    <div class="reward-row-points">
                        <img src="assets/images/points_coin.svg" class="reward-row-points-icon" alt="" />
                        <span>{{ partner.minimumPoints | number }} pts</span>
                    </div>
                    <ng-icon iconClass="icon-setting-arrow-right" width="14" height="14" class="reward-row-chevron"></ng-icon>
                </div>

                <!-- Empty state when filter returns no results -->
                <div class="reward-list-empty" *ngIf="getSortedPartners().length === 0">
                    <ng-icon iconClass="icon-filter-big" width="48" height="48"></ng-icon>
                    <div class="font-500 font-size-14px color-base-700 mt-15">
                        {{ "NoRewardsAvailable" | translate }}
                    </div>
                </div>
            </div>

            <!-- =========================================================== -->
            <!-- Mobile screen #6: Amount selection (collapsed until tapped)-->
            <!-- =========================================================== -->
            <div class="amount-region" *ngIf="selectedRadeemType">
                <div class="amount-region-divider"></div>
                <div class="amount-region-header">
                    <button class="amount-change-btn" (click)="cancelRedeem()">
                        <ng-icon iconClass="icon-back" width="14" height="14"></ng-icon>
                        {{ "Change" | translate }}
                    </button>
                    <div class="font-600 font-size-14px color-base-1700">
                        {{ selectedRadeemType }}
                    </div>
                    <div class="amount-change-spacer"></div>
                </div>

                <!-- Account input for partners that need it -->
                <div class="account-input-group mt-15"
                    *ngIf="selectedRadeemType == 'Gulf Air FFP' || selectedRadeemType == 'Etihad' || selectedRadeemType == 'Etihad Guest Miles' || selectedRadeemType == 'Qatar Airways Privilege Club'">
                    <label class="font-500 font-size-12px color-base-600 mb-8 d-block">{{"AccountNumber" | translate}}</label>
                    <div class="input-wrapper">
                        <input type="text" class="account-input" [(ngModel)]="GulfnumberDisplay"
                            [placeholder]="getSelectedPartner()?.accountNumberPlaceholder || 'Enter account number'"
                            maxlength="20">
                    </div>
                </div>

                <div class="account-input-group mt-15"
                    *ngIf="selectedRadeemType == 'Shukrans' || selectedRadeemType == 'Shukran' || selectedRadeemType == 'Jawaher Program'">
                    <label class="font-500 font-size-12px color-base-600 mb-8 d-block">{{"AccountNumber" | translate}}</label>
                    <div class="input-wrapper">
                        <input type="text" class="account-input" [(ngModel)]="shukranNumberDisplay"
                            [placeholder]="getSelectedPartner()?.accountNumberPlaceholder || 'Enter account number'"
                            maxlength="20"
                            [disabled]="!!shukranNumberDisplay">
                    </div>
                </div>

                <div class="form-group mt-15" *ngIf="!isGiveBack()">
                    <label>{{ "points" | translate }}</label>
                    <div class="has-absolute-layer-left mt-10">
                        <input type="text" class="desire-amount icon-edit pl-12"
                            (input)="onInputChange($event.target.value)" [(ngModel)]="Inputminmumvalue">
                    </div>
                </div>

                <div class="form-group mt-15" *ngIf="isGiveBack()">
                    <label>Amount (BHD)</label>
                    <div class="has-absolute-layer-left mt-10">
                        <input type="number"
                               class="desire-amount icon-edit pl-12"
                               min="1"
                               step="1"
                               inputmode="numeric"
                               pattern="[0-9]*"
                               (input)="onInputChange($event.target.value)"
                               [ngModel]="bhdSliderValue"
                               (ngModelChange)="onBhdInputChange($event)"
                               name="bhdAmountInput">
                    </div>
                </div>

                <!-- Real range slider — draggable thumb -->
                <div class="rdm-range-slider mt-20" *ngIf="!isGiveBack()">
                    <input type="range"
                           class="rdm-range-input"
                           [min]="getSliderMin()"
                           [max]="getSliderMax()"
                           [step]="getSliderStep(Inputminmumvalue || 0)"
                           [value]="Inputminmumvalue || 0"
                           (input)="onSliderChange($event.target.value)"
                           [style.--rdm-range-progress]="getRangeProgress() + '%'" />
                    <div class="rdm-range-labels">
                        <span>{{ getSliderMin() }}</span>
                        <span>{{ getSliderMax() }}</span>
                    </div>
                </div>

                <!-- Give Back range slider (BHD mode) -->
                <div class="rdm-range-slider mt-20" *ngIf="isGiveBack()">
                    <input type="range"
                           class="rdm-range-input"
                           [min]="getSliderMin()"
                           [max]="getSliderMax()"
                           [step]="getSliderStep(bhdSliderValue || 0)"
                           [value]="bhdSliderValue || 0"
                           (input)="onSliderChange($event.target.value)"
                           [style.--rdm-range-progress]="getRangeProgress() + '%'" />
                    <div class="rdm-range-labels">
                        <span>{{ getSliderMin() }} BHD</span>
                        <span>{{ getSliderMax() }} BHD</span>
                    </div>
                </div>

                <!-- Custom quick-amount presets (mobile #6 grid) — always visible -->
                <div class="custom-slider mt-15">
                    <div class="slider-presets" *ngIf="!isGiveBack()">
                        <button class="preset-btn" [class.active]="Inputminmumvalue === 1000" (click)="setPreset(1000)">1K</button>
                        <button class="preset-btn" [class.active]="Inputminmumvalue === 5000" (click)="setPreset(5000)">5K</button>
                        <button class="preset-btn" [class.active]="Inputminmumvalue === 10000" (click)="setPreset(10000)">10K</button>
                        <button class="preset-btn" [class.active]="Inputminmumvalue === 15000" (click)="setPreset(15000)">15K</button>
                        <button class="preset-btn" [class.active]="Inputminmumvalue === 20000" (click)="setPreset(20000)">20K</button>
                    </div>
                    <div class="slider-presets" *ngIf="isGiveBack()">
                        <button class="preset-btn" [class.active]="bhdSliderValue === 1" (click)="setPreset(1)">1 BD</button>
                        <button class="preset-btn" [class.active]="bhdSliderValue === 2" (click)="setPreset(2)">2 BD</button>
                        <button class="preset-btn" [class.active]="bhdSliderValue === 3" (click)="setPreset(3)">3 BD</button>
                        <button class="preset-btn" [class.active]="bhdSliderValue === 5" (click)="setPreset(5)">5 BD</button>
                        <button class="preset-btn" [class.active]="bhdSliderValue === 10" (click)="setPreset(10)">10 BD</button>
                    </div>
                </div>

                <div class="font-400 font-size-12px mt-15 color-base-1200 text-align-center">
                    <span *ngIf="!isGiveBack()">{{selectedPoint | number}} {{ "points" | translate}} = {{Amount}} {{getRedemptionUnit()}}</span>
                    <span *ngIf="isGiveBack()">{{getDisplayValue()}} BHD = {{selectedPoint | number}} pts</span>
                </div>

                <div class="mt-30">
                    <button class="btn-dft" (click)="Next()" [disabled]="isValid()">
                        {{ "Next" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- =========================================================== -->
<!-- Mobile screen #5: Reward Details Modal                     -->
<!-- Custom modal — full control over markup, no shared         -->
<!-- ModalComponent pollution (no done button, no footer).      -->
<!-- =========================================================== -->
<div class="rdm-backdrop"
     *ngIf="detailsModalOpen"
     (click)="closeDetailsModal()"></div>
<div class="rdm-modal"
     *ngIf="detailsModalOpen">
    <div class="rdm-canvas">
        <button class="rdm-close" type="button" (click)="closeDetailsModal()" aria-label="Close">
            <ng-icon iconClass="icon-close-10px" width="14" height="14"></ng-icon>
        </button>

        <div class="rdm-body" *ngIf="detailsPartner">
            <div class="reward-details-icon">
                <img *ngIf="detailsPartner.imageUrl" [src]="detailsPartner.imageUrl" alt="" (error)="detailsPartner.imageUrl = ''" />
                <div *ngIf="!detailsPartner.imageUrl" class="reward-details-icon-fallback">
                    <span class="reward-details-icon-letter">{{ (detailsPartner.displayValue || '?').charAt(0) }}</span>
                </div>
            </div>

            <div class="font-600 font-size-16px color-base-1700 mt-12 reward-details-name">
                {{ detailsPartner.displayValue }}
            </div>

            <span class="reward-row-category-chip mt-5">{{ detailsPartner.category }}</span>

            <div class="conversion-rate-box mt-15">
                <div class="font-400 font-size-11px color-base-600 conversion-rate-label">
                    {{ "ConversionRate" | translate }}
                </div>
                <div class="font-600 font-size-14px color-base-1700 mt-5">
                    {{ getConversionDisplay(detailsPartner) }}
                </div>
            </div>

            <!-- Metadata block: minimum points, provider, requirements -->
            <div class="rdm-meta mt-15">
                <div class="rdm-meta-row" *ngIf="detailsPartner.minimumPoints">
                    <div class="rdm-meta-label">{{ "MinimumPoints" | translate }}</div>
                    <div class="rdm-meta-value">{{ detailsPartner.minimumPoints | number }} {{ "points" | translate }}</div>
                </div>
                <div class="rdm-meta-row" *ngIf="detailsPartner.provider">
                    <div class="rdm-meta-label">{{ "Provider" | translate }}</div>
                    <div class="rdm-meta-value">{{ detailsPartner.provider }}</div>
                </div>
                <div class="rdm-meta-row" *ngIf="detailsPartner.requiresAccountNumber">
                    <div class="rdm-meta-label">{{ "AccountRequired" | translate }}</div>
                    <div class="rdm-meta-value">
                        <ng-container *ngIf="detailsPartner.accountNumberValidationType">
                            {{ detailsPartner.accountNumberValidationType | titlecase }}
                        </ng-container>
                        <ng-container *ngIf="!detailsPartner.accountNumberValidationType">
                            {{ "Yes" | translate }}
                        </ng-container>
                        <ng-container *ngIf="detailsPartner.accountNumberLength">
                            ({{ detailsPartner.accountNumberLength }} {{ "digits" | translate }})
                        </ng-container>
                    </div>
                </div>
                <div class="rdm-meta-row" *ngIf="detailsPartner.requiresFirstName || detailsPartner.requiresLastName">
                    <div class="rdm-meta-label">{{ "NameRequired" | translate }}</div>
                    <div class="rdm-meta-value">
                        <ng-container *ngIf="detailsPartner.requiresFirstName">{{ "FirstName" | translate }}</ng-container>
                        <ng-container *ngIf="detailsPartner.requiresFirstName && detailsPartner.requiresLastName"> &amp; </ng-container>
                        <ng-container *ngIf="detailsPartner.requiresLastName">{{ "LastName" | translate }}</ng-container>
                    </div>
                </div>
            </div>

            <div class="font-500 font-size-13px color-base-1500 mt-20 text-align-left">
                {{ "AboutThisReward" | translate }}
            </div>
            <div class="font-400 font-size-13px color-base-1200 mt-8 line-h-20 text-align-left">
                {{ detailsPartner.description }}
            </div>

            <button class="btn-dft mt-20 w-100" (click)="confirmRedeemFromModal()">
                {{ "REDEEM" | translate }}
            </button>

            <!-- Optional second button: opens partner's T&C link in a new tab -->
            <a *ngIf="detailsPartner.hasTermsConditions"
               class="btn-dft-border mt-10 w-100 rdm-tc-link"
               [href]="detailsPartner.termsConditionsUrl"
               target="_blank"
               rel="noopener noreferrer"
               (click)="onTermsConditionsClick($event)">
                {{ "TermsAndConditions" | translate }}
            </a>

            <!-- Optional third button: opens partner's website in a new tab -->
            <a *ngIf="detailsPartner.hasWebsite"
               class="rdm-website-link mt-10"
               [href]="detailsPartner.websiteUrl"
               target="_blank"
               rel="noopener noreferrer">
                <ng-icon iconClass="icon-setting-arrow-right" width="12" height="12"></ng-icon>
                {{ "VisitWebsite" | translate }}
            </a>

            <div class="font-400 font-size-12px color-base-600 text-align-center mt-12">
                {{ "YourBalance" | translate }}
                <span class="font-600 color-base-1700">
                    {{ (redeem?.LoyaltyCard?.rewardsBalance | number:'1.0-0') || '—' }}
                </span>
                {{ "LoyaltyPoints" | translate }}
            </div>
        </div>
    </div>
</div>

<!-- Disclaimer modal (kept for the existing Next() flow) -->
<modal modalID="1" modalClass="height-auto-flex" [events]="modalObservable.asObservable()" [backdropDismiss]="true"
    modalDoneButtonText="CONFIRM" (doneButton)="Next()" [whiteButtonStatus]="true" whiteButtonText="CANCEL" [modalDoneButtonStatus]="true">
    <div class="text-align-center">
        <ng-icon iconClass="icon-disclaimer" width="72" height="72"></ng-icon>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10 mt-30">
            {{ "DearValuedCustomer" | translate }}
        </div>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10 mt-10">
            {{ "Beforeproceedingwiththetransfer" | translate }}
        </div>
    </div>
</modal>